import { render } from "./PropertyModul.vue?vue&type=template&id=2514f6d5"
import script from "./PropertyModul.vue?vue&type=script&lang=js"
export * from "./PropertyModul.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__